import Vue from 'vue'
import featureToggle from '@/utils/featureToggle'

Vue.directive('toggle', {
  inserted(_, binding, vnode) {
    const isEnabled = featureToggle(binding.value)
    if (!isEnabled) vnode.elm.parentElement.removeChild(vnode.elm)
  },
})
